export default {
  get_all: { method: "get", url: "api/sources" },
  show: { method: "get", url: "api/sources{/id}" },
  store: { method: "post", url: "api/sources" },
  update: { method: "put", url: "api/sources{/id}" },
  delete: { method: "delete", url: "api/sources{/id}" }
};
